import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetaaldatumWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#6FBC85"
      d="M32 10H8v22h24z"
    />
    <path
      fill="#A8D3AF"
      d="M32 13.89H8V32h24z"
    />
    <path
      fill="#00A75D"
      d="M12.5 8h-1v4h1zM16.5 8h-1v4h1zM20.5 8h-1v4h1zM24.5 8h-1v4h1zM28.5 8h-1v4h1zM18.83 16.43h-3v3h3zM24.17 16.43h-3v3h3zM29.5 16.43h-3v3h3zM18.83 21.5h-3v3h3zM13.5 21.5h-3v3h3zM24.17 21.5h-3v3h3zM29.5 21.5h-3v3h3zM18.83 26.57h-3v3h3zM13.5 26.57h-3v3h3zM24.17 26.57h-3v3h3zM29.5 26.57h-3v3h3z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetaaldatumWijzigen);

export default ForwardRef;
